import { shopCategoriesService } from '@afterpaytouch/shop-api/categories'

export const { useGetCategoriesQuery } = shopCategoriesService
